"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Scale, ShieldAlert, FileText, ArrowRight, Clock, CircleAlert as AlertCircle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const termClauses = [{
  id: 1,
  number: "01",
  title: "Vekâlet ve Avukat–Müvekkil İlişkisi",
  description: "Bu iletişim formunun doldurularak gönderilmesi, tek başına bir avukatlık sözleşmesi, vekâlet akdi veya hukuken bağlayıcı bir avukat–müvekkil ilişkisi kurmaz."
}, {
  id: 2,
  number: "02",
  title: "Randevu Taleplerinin Teyidi",
  description: "Form üzerinden iletilen randevu talepleri, Yüksekbaş Hukuk ve Danışmanlık tarafından ayrıca yazılı veya sözlü olarak teyit edilmedikçe kesinleşmiş sayılmaz."
}, {
  id: 3,
  number: "03",
  title: "Danışmanlık Ücreti ve Avukatlık Kanunu",
  description: "Hukuki danışmanlık hizmetleri, 1136 sayılı Avukatlık Kanunu ve yürürlükteki Avukatlık Asgari Ücret Tarifesi çerçevesinde ücrete tabidir. İletişim formunun gönderilmesi, ücretsiz hukuki danışmanlık hizmeti verileceği anlamına gelmez."
}, {
  id: 4,
  number: "04",
  title: "Süreye Tabi ve Acil Hukuki İşlemler",
  description: "Kanuni, usulî veya hak düşürücü süreye tabi işlemler bakımından yalnızca iletişim formunun gönderilmiş olmasına dayanılmamalıdır. Hak kayıplarının önüne geçmek adına acil veya süreye tabi konularda büromuzla doğrudan iletişime geçilmelidir."
}, {
  id: 5,
  number: "05",
  title: "Kişisel Verilerin Korunması ve Sınırlandırılması",
  description: "Form üzerinden zorunlu ve elzem olmadıkça özel nitelikli kişisel veriler (sağlık, ceza mahkûmiyeti vb.) veya üçüncü kişilere ait hassas kişisel veriler iletilmemelidir."
}, {
  id: 6,
  number: "06",
  title: "Evrak ve Belge İletimi",
  description: "Uyuşmazlığa veya hukuki duruma ilişkin dosya, evrak veya belge iletilmesi gerektiğinde, konuya uygun güvenli iletişim yöntemi ve kanalı büromuzca ayrıca bildirilecektir."
}];
const relatedLinks = [{
  id: 1,
  title: "İletişim Formu Aydınlatma Metni",
  path: "/ContactFormPrivacyNoticePage"
}, {
  id: 2,
  title: "KVKK Politikası",
  path: "/PersonalDataProtectionAndProcessingPolicyPage"
}, {
  id: 3,
  title: "Büro İletişim Bilgileri",
  path: "/ContactPage"
}];
export default function FormTerms() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.08,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0,
      y: shouldReduceMotion ? 0 : 14
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: "easeOut"
      }
    }
  };
  return <section id="contactformtermsofuse" data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 lg:py-32 border-b border-border selection:bg-muted selection:text-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="space-y-6 max-w-3xl mb-14 md:mb-18">
          <motion.div variants={itemVariants} className="flex flex-wrap items-center gap-3">
            <Badge variant="outline" className="border-border text-foreground font-sans text-xs tracking-wide uppercase px-3 py-1 rounded-none">
              <Scale className="size-3.5 text-muted-foreground mr-1" />
          HUKUKİ BİLGİLENDİRME
            </Badge>
            <div className="flex items-center gap-1.5 text-xs font-sans text-muted-foreground">
              <Clock className="size-3.5" />
              <span>Yürürlük Tarihi: Güncel</span>
            </div>
          </motion.div>

          <motion.h1 variants={itemVariants} className="text-3xl sm:text-4xl md:text-5xl font-serif font-normal leading-tight text-foreground tracking-tight uppercase">
          İLETİŞİM FORMU KULLANIM KOŞULLARI
          </motion.h1>

          <motion.p variants={itemVariants} className="text-base sm:text-lg font-sans text-muted-foreground font-light leading-relaxed">
            Yüksekbaş Hukuk ve Danışmanlık web sitesi üzerinde yer alan iletişim formu aracılığıyla tarafımıza ulaşırken dikkate alınması gereken yasal çerçeve ve kullanım esasları aşağıda düzenlenmiştir.
          </motion.p>

          <motion.div variants={itemVariants} className="pt-2">
            <Separator className="bg-border" />
          </motion.div>
        </motion.div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-16">
          {termClauses.map((clause, i) => <motion.div key={clause.id} data-index={i} variants={itemVariants} className="group relative border border-border bg-card p-6 sm:p-8 flex flex-col justify-between transition-colors hover:border-foreground/40">
              <div>
                <div className="flex items-baseline justify-between gap-4 mb-4">
                  <span className="font-mono text-xs font-medium text-muted-foreground tracking-widest">
                    MADDE {clause.number}
                  </span>
                  <div className="h-px flex-1 bg-border/50 mx-2" />
                  <AlertCircle className="size-4 text-muted-foreground opacity-60 group-hover:opacity-100 transition-opacity" />
                </div>

                <h2 className="text-xl sm:text-2xl font-serif font-medium text-foreground mb-3 leading-snug">
                  {clause.title}
                </h2>

                <p className="text-sm sm:text-base font-sans text-muted-foreground leading-relaxed font-light">
                  {clause.description}
                </p>
              </div>

              <div className="mt-6 pt-4 border-t border-border/40 flex items-center justify-between text-xs font-mono text-muted-foreground">
                <span>Yüksekbaş Hukuk</span>
                <span className="text-[10px] tracking-wider uppercase">Bağlayıcılık Kaydı</span>
              </div>
            </motion.div>)}
        </motion.div>

        {}
        <motion.div variants={itemVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="border border-border bg-muted/40 p-6 sm:p-8 lg:p-10">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8">
            <div className="space-y-3 max-w-xl">
              <div className="flex items-center gap-2 text-foreground font-serif text-lg font-medium">
                <ShieldAlert className="size-5 text-muted-foreground" />
                <h3>Önemli Hatırlatma</h3>
              </div>
              <p className="text-sm font-sans text-muted-foreground leading-relaxed font-light">
                İletişim formunun iletilmesi acil tebligat, dava açma, itiraz veya kanuni müracaat sürelerini durdurmaz veya kesintiye uğratmaz. İvedi hukuki yardım gerektiren hallerde doğrudan büro telefonlarımız üzerinden irtibat sağlayınız.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row lg:flex-col gap-3 min-w-[240px]">
              <span className="text-xs font-mono uppercase text-muted-foreground tracking-wider mb-1">
                İLGİLİ HUKUKİ METİNLER
              </span>
              {relatedLinks.map((link, i) => <div key={link.id} data-index={i}>
                  <Link to={link.path} className="inline-flex items-center justify-between w-full text-xs sm:text-sm font-sans text-foreground hover:text-foreground/80 py-1.5 border-b border-border/60 hover:border-foreground transition-colors group">
                    <span className="flex items-center gap-2">
                      <FileText className="size-3.5 text-muted-foreground group-hover:text-foreground transition-colors" />
                      {link.title}
                    </span>
                    <ArrowRight className="size-3.5 text-muted-foreground group-hover:translate-x-0.5 transition-transform" />
                  </Link>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}